import { OidcAccessToken } from '@ori/auth';
export var getToken = async function getToken(_ref) {
  var _window$ori;
  var token = _ref.token;
  if (token) {
    return new OidcAccessToken(token);
  }
  if ((_window$ori = window.ori) !== null && _window$ori !== void 0 && _window$ori.tokenService) {
    var oriToken = await window.ori.tokenService.getToken();
    if (oriToken) {
      return new OidcAccessToken(oriToken.Token);
    }
  }
  return null;
};